import { getHotWords, updateHotWords } from "@/services/simulInter";
import { message } from "antd";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
interface AutoTransEnhanceTipsProps {
  streamName: string;
  handleCover: () => void;
  handleShowTransEnhanceModal: () => void;
}

export interface AutoTransEnhanceTipsRef {
  startPollingHotWords: (streamName: string) => void;
  handleHideTips: () => void;
  coverHotWords: (firstUpload: boolean, newHotWords: string[]) => void;
}

const AutoTransEnhanceTips = forwardRef<
  AutoTransEnhanceTipsRef,
  AutoTransEnhanceTipsProps
>((props, ref) => {
  const { streamName, handleShowTransEnhanceModal, handleCover } = props;
  const [hotwords, setHotwords] = useState<string[]>([]);
  const [visible, setVisible] = useState(false);
  const abortControllerRef = useRef(new AbortController());
  const [firstUpload, setFirstUpload] = useState(true);

  const startPollingHotWords = async (
    streamName: string,
  ) => {
    console.log("startPollingHotWords");
    try {
      const res = await getHotWords(streamName, {
        signal: abortControllerRef.current.signal,
      });
      setHotwords(res.data.words);
      setVisible(true);
    } catch (error) {
      console.log("getHotWords error", error);
    }
  };

  const coverHotWords = async (firstUpload: boolean, newHotWords: string[]) => {
    handleHideTips();
    setFirstUpload(firstUpload);
    setHotwords(newHotWords);
    setVisible(true);
  };

  const handleHideTips = () => {
    setVisible(false);
  };

  const handleConfirm = async () => {
    try {
      await updateHotWords({ streamName, words: hotwords, enhanceEnable: true });
      handleShowTransEnhanceModal();
      handleHideTips();
    } catch (error) {
      console.log("updateHotWords error", error);
      message.error("开启转写增强失败，请重试");
    }
  };

  useImperativeHandle(ref, () => ({
    startPollingHotWords,
    handleHideTips,
    coverHotWords
  }));

  return (
    visible && (
      <div className="w-82 h-30 px-4 py-3 absolute bottom-4 left-4 right-4 bg-gradient-to-r from-#9587F3 to-#6D9DFF rounded-2 border-1px border-solid border-#F4F6F9">
        <div className="text-3 text-#fff">
          {firstUpload
            ? "开启转写增强，提升转写准确率，已提取热词："
            : "发言稿更新，已提取到新热词："}
        </div>
        <div className="mt-1 text-3 text-#fff/50 text-ellipsis whitespace-nowrap overflow-hidden">
          {hotwords.join(",")}
        </div>
        <div className="mt-6 flex justify-end">
          <div
            className="cursor-pointer w-18 h-7 rd-1.5 text-#fff border-1px border-solid border-#FFF/30 font-500 flex items-center justify-center text-3"
            onClick={handleHideTips}
          >
            忽略
          </div>
          {firstUpload ? (
            <div
              className="cursor-pointer ml-2 w-18 h-7 rd-1.5 bg-#fff text-mx-primary border-1px border-solid border-#FFF/50 font-500 flex items-center justify-center text-size-3"
              onClick={handleConfirm}
            >
              立即开启
            </div>
          ) : (
            <div
              className="cursor-pointer ml-2 w-18 h-7 rd-1.5 bg-#fff text-mx-primary border-1px border-solid border-#FFF/50 font-500 flex items-center justify-center text-size-3"
              onClick={handleCover}
            >
              直接覆盖
            </div>
          )}
        </div>
      </div>
    )
  );
});

export default AutoTransEnhanceTips;
